const TrainingModes = {
    ML_LLM: 1,
    LLM_ONLY: 2,
    ML_ONLY: 3,
}

export default TrainingModes
